export const columnFields = [
	'organization.name',
	'project.name',
	'customer.name',
	//
	'name',
	'variation',
	'original',
	//
	'pagesToCompare',
	//
	'createdBy.name',
	'createdAt',
	//
	'status.name',
] as const;
